import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { GlobalContext } from "./context/GlobalContext";

const PrivateAdminRoute = ({ children }) => {
  const { globalState } = useContext(GlobalContext);

  // Wait for the authoritative super-admin check before deciding. While it's
  // still resolving (or during initial load) render nothing rather than
  // redirecting, so a real admin landing directly on an admin route isn't
  // bounced to "/" before the claim/vendor check completes.
  if (globalState.loading || !globalState.adminResolved) return null;

  if (!globalState.isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateAdminRoute;
